module.exports = ".contact-text {\n  color: black;\n  padding-bottom: 5vw;\n  max-width: 80vw;\n}\n"